/*
 * The footer's Contact link opens a small dialog of mail shortcuts.
 *
 * The address is put together here, when the dialog opens, so it never appears
 * whole in the page source: harvesters that scrape HTML for mailto links or
 * anything@anything find nothing. It is a plus-address of the main inbox, which lets a Gmail filter
 * label mail from the website and, if spam ever finds it, shows it came from
 * here. Without script the link just goes to the privacy page's contact card.
 *
 * Subjects stay in English whatever the page language, so every message lands
 * under the same "[nocap] ..." prefix.
 */
(function () {
    'use strict';

    var dialog = document.querySelector('[data-contact-dialog]');
    var opener = document.querySelector('[data-contact-open]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') return;

    var SUBJECTS = {
        feedback: '[nocap] Feedback',
        bug: '[nocap] Bug report',
        data: '[nocap] Data request',
    };

    var COPIED_FOR_MS = 2000;

    /* The halves live in the markup, not here: the minifier folds string
       literals, so any address assembled in this file ships whole. */
    function address() {
        return dialog.getAttribute('data-contact-user') + '@' + dialog.getAttribute('data-contact-domain');
    }

    function fillIn() {
        var to = address();
        // An unescaped "+" in a mailto: URL can be read as a space by some clients.
        var href = 'mailto:' + to.replace('+', '%2B');

        var links = dialog.querySelectorAll('[data-contact-topic]');
        for (var i = 0; i < links.length; i++) {
            var subject = SUBJECTS[links[i].getAttribute('data-contact-topic')];
            links[i].href = href + '?subject=' + encodeURIComponent(subject);
        }

        dialog.querySelector('[data-contact-address]').textContent = to;
    }

    opener.addEventListener('click', function (event) {
        event.preventDefault();
        fillIn();
        dialog.showModal();
    });

    dialog.querySelector('[data-contact-close]').addEventListener('click', function () {
        dialog.close();
    });

    dialog.addEventListener('click', function (event) {
        // The panel fills the dialog, so a click on the dialog itself is the backdrop.
        if (event.target === dialog) {
            dialog.close();
            return;
        }
        // The mail app takes over from here.
        if (event.target.closest('[data-contact-topic]')) dialog.close();
    });

    var copy = dialog.querySelector('[data-contact-copy]');
    var resetTimer = null;

    if (!navigator.clipboard) {
        // Plain http or an old browser: the address is still selectable by hand.
        copy.hidden = true;
    } else {
        copy.addEventListener('click', function () {
            navigator.clipboard.writeText(address()).then(function () {
                copy.classList.add('is-copied');
                clearTimeout(resetTimer);
                resetTimer = setTimeout(function () {
                    copy.classList.remove('is-copied');
                }, COPIED_FOR_MS);
            }, function () {
                window.getSelection().selectAllChildren(dialog.querySelector('[data-contact-address]'));
            });
        });
    }
})();
